export const CUSTOMER_MANAGEMENT_SET_SELECTED = 'CUSTOMER_MANAGEMENT_SET_SELECTED';
